import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import { HTLabel } from './ht'
import { TTCLabel } from './ttc'
import { usePriceContext, VAT_STATUS } from '../../../contexts'

interface VatLabelProps {
  color?: 'main' | 'subtitle' | 'discount'
}
const VatLabel = ({ color = 'main' }: VatLabelProps) => {
  const { vatStatus } = usePriceContext()

  const className = computeClassName({ color })

  return vatStatus === VAT_STATUS.HT ? (
    <HTLabel className={className} />
  ) : (
    <TTCLabel className={className} />
  )
}

export default VatLabel

const computeClassName = ({ color }: VatLabelProps) => {
  return clsx({
    [s.main]: color === 'main',
    [s.subtitle]: color === 'subtitle',
    [s.green]: color === 'discount',
  })
}
